import { ArrowOne } from './ArrowOne';

export const Arrows = ({ rotate, currentItemId }) => {
  return <ArrowOne rotate={rotate} currentItemId={currentItemId} />;
};
